import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "@fontsource/poppins/400.css";
import "@fontsource/poppins/500.css";
import "@fontsource/poppins/600.css";
import "@fontsource/poppins/700.css";
import {
  consoleLoggingIntegration,
  init,
  reactRouterV7BrowserTracingIntegration,
  replayIntegration,
} from "@sentry/react";
import { useEffect } from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import "./index.css";
import { Entry } from "./entry";

const hostname = window.location.hostname;
const environment = hostname.includes(".develop.") ? "develop" : "production";

init({
  dsn: "https://800a307a490410c2794f7489787bf444@o180763.ingest.us.sentry.io/4509525658304512",
  enabled: hostname.endsWith(".voyc.ai"),
  environment,
  sendDefaultPii: true,
  integrations: [
    consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    replayIntegration(),
    reactRouterV7BrowserTracingIntegration({
      useEffect: useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  replaysSessionSampleRate: 0.2,
  replaysOnErrorSampleRate: 1.0,
  enableLogs: true,
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}

createRoot(rootElement).render(
  <StrictMode>
    <Entry />
  </StrictMode>,
);
